/* eslint-disable camelcase */
import { Moment } from 'moment';
import { Countries } from 'shared/enums';
import { create } from 'zustand';

export type FullDataAccessChannel = {
  channel: string;
  linkToAccountDashboard: string;
  accessOwner: string;
  digitalConsultant: string;
};

export type WithoutFullDataAccessChannel = {
  benchmark: string;
  channel: string;
  impressions: number;
  cpm: string;
  cost: number;
  numberOfDays: number;
  cpc: number;
  clicks: number;
};

export interface DigitalFairValueFormData {
  divisions: { id: number; title: string }[];
  brands: { id: number; title: string }[];
  partner: string;
  startDate: Moment | null;
  endDate: Moment | null;
  step: number;
  acceptDedAndInvoiceIssuedGranularly: string | null;
  isRoasConfirmed: boolean;
  acceptReceivingFullSalesFromThePartner: string | null;
  dashboardExcel: string;
  partialChannels: WithoutFullDataAccessChannel[];
  fullChannels: FullDataAccessChannel[];
  currentStep: number;
}

interface StoreDigitalFairValue {
  formData: DigitalFairValueFormData;
  updateForm: (newForm?: DigitalFairValueFormData) => void;
  resetForm: () => void;
}

export const useDigitalFairValueFormStore = create<StoreDigitalFairValue>(
  (set) => ({
    formData: {} as DigitalFairValueFormData,
    updateForm: (newForm?: DigitalFairValueFormData) =>
      set((state) => ({
        ...state,
        formData: newForm || ({} as DigitalFairValueFormData),
      })),
    resetForm: () => {
      set((state) => ({
        ...state,
        formData: {
          divisions: [],
          brands: [],
          partner: '',
          startDate: null,
          endDate: null,
          step: 0,
          currentStep: 0,
          acceptDedAndInvoiceIssuedGranularly: null,
          isRoasConfirmed: false,
          acceptReceivingFullSalesFromThePartner: null,
          dashboardExcel: '',
          partialChannels: [],
          fullChannels: [],
        } as DigitalFairValueFormData,
      }));
    },
  })
);

export type CountrySetup = {
  divisions: string;
  brands: string[];
  category: string;
  countries: Countries | null;
};

export type TouchPointsSetup = CountrySetup & {
  campaignType: string;
  segment: string;
};

export type YoutubeTouchPoint = {
  yt_bumper_share_min: number | null;
  yt_bumper_share_max: number | null;
  yt_bumper_share_reco: number | null;
  yt_unskip_share_min: number | null;
  yt_unskip_share_max: number | null;
  yt_unskip_share_reco: number | null;
  yt_aw_tg_sat_min: number | null;
  yt_aw_tg_sat_max: number | null;
  yt_aw_tg_sat_default: number | null;
};
